import React from 'react';
import Grid from '@material-ui/core/Grid';
import Container from '../../../components/dashboard/container';
import { isLolaAdmin } from '../../../components/access';
import { withAuthorization } from '../../../model/Session';
import * as ROUTES from '../../../constants/routes';
import ExpresionForm from './form';

const ExpresionNew = () => (
  <Container backPath={ROUTES.EXPRESIONES} title="Nueva Expresión Artística">
    <Grid container spacing={3} justify="center">
      <Grid item xs={12} md={6}>
        <ExpresionForm />
      </Grid>
    </Grid>
  </Container>
);

export default withAuthorization(isLolaAdmin)(ExpresionNew);
